export default __webpack_public_path__ + "static/media/Payroll-Main-page-final-2.e79b57ad.png";